import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  children: ReactNode;
  onClose?: () => void;
  /** z-index слоя (drawer 80, nested sheet 90) */
  zIndex?: number;
};

/**
 * Полноэкранный оверлей в document.body — без backdrop-filter (ломает WebView Telegram → чёрный экран).
 */
export function AdminOverlayPortal({ children, onClose, zIndex = 80 }: Props) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return createPortal(
    <div
      className="fixed inset-0 flex flex-col"
      style={{
        zIndex,
        background: '#0A192F',
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
      role="dialog"
      aria-modal="true"
    >
      {onClose && (
        <button
          type="button"
          aria-label="Закрыть"
          className="absolute inset-0 z-0 cursor-default"
          style={{ background: 'transparent' }}
          onClick={onClose}
        />
      )}
      <div className="relative z-10 flex flex-col flex-1 min-h-0 w-full">{children}</div>
    </div>,
    document.body,
  );
}
